import {
  type SalaryCurrency,
  SalaryCurrencyActiveMap,
  type SalaryCurrencyLegacy,
  SalaryCurrencyLegacyMap,
  SalaryCurrencyLegacyValues,
} from '@seek/salary-data';

import { getOptionText } from 'src/app/utils/getOptionText';
import type { DraftJobSalaryCurrency } from 'src/graphql/generated';
import type { Option } from 'src/types/formFields';

const generateOptions = (obj: Record<string, string>): Option[] =>
  Object.entries(obj).map(([value, text]) => ({ value, text }));

export const useSalaryCurrencyTaxonomy = (
  currentSalaryCurrency: SalaryCurrency | null = null,
) => {
  const isLegacySalaryCurrency = (currency: SalaryCurrency | null): boolean =>
    SalaryCurrencyLegacyValues.includes(currency as SalaryCurrencyLegacy);

  const currencyWithText: Record<string, string> = {
    ...SalaryCurrencyActiveMap,
    ...(isLegacySalaryCurrency(currentSalaryCurrency) && {
      ...SalaryCurrencyLegacyMap,
    }),
  };

  // sort A-Z
  const sortedCurrencyWithText = Object.fromEntries(
    Object.entries(currencyWithText).sort((a, b) => a[0].localeCompare(b[0])),
  );

  const currencyOptions = generateOptions(sortedCurrencyWithText);

  const getCurrencyText = (value: DraftJobSalaryCurrency) =>
    getOptionText(currencyOptions, value);

  return {
    currencyOptions,
    getCurrencyText,
  };
};
